import React from "react";
import TableAutoComponent from "../../components/complex/crud/TableAutoComponent";
import FilterComponent from "../../components/complex/crud/FilterComponent";
import generateFilterConfigs from "../../utils/FilterConfigGenerator";
import generateTableConfigs from "../../utils/TableConfigGenerator";

import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Paginator } from "primereact/paginator";

import useSelectorDialogControl from "../../custom_hooks/complex/useSelectorDialogControl";

const title = "Product";
const apiName = "masterdata/product";
const orderBy = "id";
const orderMethod = "ASC";
const additionalParams = { with_product_category: 1 };

const customColumns = [];

const configs = [
  // add_configs
  {
    name: "Product Display",
    field: "product_display_id",
    type: "object",
    object_name: "data_product_display",
    object_field: "name",
    editor: true,
    table: false,
    filter: true,
  },
  {
    name: "Product  Category",
    field: "product_category_id",
    type: "object",
    object_name: "data_product_category",
    object_field: "name",
    editor: true,
    table: true,
    filter: true,
  },
  {
    name: "Code",
    field: "code",
    type: "text_plain",
    table: false,
    filter: true,
    editor: true,
  },
  {
    name: "Name",
    field: "name",
    type: "text_plain",
    filter_default: true,
    table: true,
    filter: true,
    editor: true,
  },
  {
    name: "Price",
    field: "price",
    type: "number_plain",
    editor: true,
    align: "right",
    table: false,
  },
  {
    name: "Product Type",
    field: "product_type",
    table: false,
    filter: true,
    editor: true,
    type: "number_plain",
    align: "right",
  },
  {
    name: "Point",
    field: "point",
    type: "number_plain",
    editor: true,
    align: "right",
    table: false,
  },
  {
    name: "Level",
    field: "level",
    table: false,
    filter: true,
    editor: true,
    type: "number_plain",
    align: "right",
  },
  {
    name: "Redeemable",
    field: "redeemable",
    align: "center",
    table: false,
    editor: true,
    type: "boolean_plain",
    filter: true,
  },
  {
    name: "Description",
    field: "description",
    type: "text_plain",
    table: false,
    filter: true,
    editor: true,
  },
  {
    name: "Benefit",
    field: "benefit",
    type: "text_plain",
    table: false,
    filter: true,
    editor: true,
  },
  {
    name: "Duration",
    field: "duration",
    type: "number_plain",
    editor: true,
    align: "right",
    table: false,
  },
];

const filterConfigs = generateFilterConfigs(configs);
const tableConfigs = generateTableConfigs(configs);

const ProductSelectorDialog = (props) => {
  const single = props.single ?? true;

  const {
    toast,
    listData,
    paging,
    loading,
    setListData,
    selectedRows,
    setSelectedRows,
    refineValue,
    reloadListData,
    handleOnFilter,
    handleOnPage,
    handleSelectionChange,
  } = useSelectorDialogControl({
    apiName,
    orderBy,
    orderMethod,
    additionalParams,
    additionalFilter: props.additionalFilter,
    visible: props.visible,
  });

  const dialogFooter = (
    <div className="col-center-center w-100">
      <Paginator
        first={paging.take * (paging.page - 1)}
        rows={paging.take}
        totalRecords={paging.total}
        rowsPerPageOptions={[5, 8, 10, 20, 50]}
        onPageChange={handleOnPage}
      />
      <div className="row-end-end w-100">
        <Button
          label="Cancel"
          icon="pi pi-times"
          outlined
          onClick={props.onHide}
        />
        <Button
          label="Pilih"
          icon="pi pi-check"
          onClick={(e) => {
            const refinedValue = refineValue(selectedRows);
            props.onConfirm(e, refinedValue);
          }}
        />
      </div>
    </div>
  );

  return (
    <Dialog
      visible={props.visible}
      header={title}
      modal
      className={`p-fluid w-[23rem] sm:w-[55rem] min-h-[40rem]`}
      footer={dialogFooter}
      onHide={props.onHide}
      contentStyle={{ paddingBottom: "0px" }}
    >
      <div className={`col-start-start w-100 gap-3`}>
        {filterConfigs && filterConfigs.length > 0 && (
          <FilterComponent onFilter={handleOnFilter} configs={filterConfigs} />
        )}
        <div className={`col-center-center w-100 gap-2`}>
          <TableAutoComponent
            selectable
            singleMode={single}
            selectedRows={selectedRows}
            selection={selectedRows}
            onSelectionChange={handleSelectionChange}
            configs={tableConfigs}
            loading={loading}
            value={listData}
            customColumns={customColumns}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default ProductSelectorDialog;
